import { EventInput } from '@fullcalendar/core';
import { CalendarEvent, Task, Timestamp, WeekDays } from '@griply/types';
import { getTasksCalendarEvents } from '@griply/utils';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
  today: Timestamp;
  weekStartsOn: WeekDays;
  hideCompleted?: boolean;
};

const mapToEventInput = (event: CalendarEvent): EventInput => ({
  id: event.id,
  date: event.date,
  start: event.start.dateTime ? new Date(event.start.dateTime) : undefined,
  end: event.end.dateTime ? new Date(event.end.dateTime) : undefined,
  title: event.title,
  allDay: event.allDay,
  extendedProps: {
    taskId: event.taskId,
    goalId: event.goalId,
    occurrenceId: event.occurrenceId,
    isDeadline: event.isDeadline,
    duration: event.duration,
  },
});

export const getTasksEventsForDateRange = (
  tasks: Task[],
  options: Options,
): EventInput[] => getTasksCalendarEvents(tasks, options).map(mapToEventInput);
